import React from 'react'
import styled from 'styled-components'
import { getCellValue } from '@components/Table/TableRow'

export default ({ row, col, isHeader, expanded, onExpand }) => {
    if (!col || isHeader !== col.isMobileTileHeader) {
        return null
    }

    return (
        <Row>
            {col.label && <Label>{col.label}: </Label>}

            {col.property === 'expand' ? (
                <ButtonContainer>
                    {col.cell(row, col, onExpand, expanded)}
                </ButtonContainer>
            ) : (
                <Value>{getCellValue(row, col)}</Value>
            )}
        </Row>
    )
}

const Row = styled.div`
    display: flex;
    white-space: nowrap;
    align-items: center;
`

const Label = styled.div`
    /* width: 72px; */
    font-weight: bold;
    min-width: 80px;
`

const Value = styled.div`
    flex: 2;
    padding: 0px 12px;
    white-space: normal;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 12px auto 0px;
`
